<div *ngIf="showBanner" class="cookie-consent-banner">
  <p>This website uses cookies to improve your experience. By using this site, you agree to our use of cookies.</p>
  <button (click)="acceptConsent()">Accept</button>
</div>
